/* eslint-disable import/no-cycle */
import OrganizationActionTypes from '../types/organization';

const initialBasicState = {
  data: null,
  loading: false,
  error: false,
};

export default (state = initialBasicState, { type, payload, error }) => {
  switch (type) {
    case OrganizationActionTypes.LOAD_ORGANIZATION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case OrganizationActionTypes.LOAD_ORGANIZATION_SUCCESS:
      return {
        ...state,
        ...payload,
        loading: false,
      };
    case OrganizationActionTypes.LOAD_ORGANIZATION_FAILURE:
      return {
        ...state,
        error,
        loading: false,
      };
    default:
      return state;
  }
};
